"use client";

import Link from "next/link";

import { useTranslation } from "@/lib/hooks/use-translation";
import { BlogPost, filterPostsByLanguage } from "../data/blog-posts";
import { blogHref } from "../data/paths";
import { BlogCard } from "./blog-card";

type RelatedBlogSectionProps = {
  posts: BlogPost[];
};

export function RelatedBlogSection({ posts }: RelatedBlogSectionProps) {
  const { t, language } = useTranslation();
  const visible = filterPostsByLanguage(posts, language);

  if (visible.length === 0) {
    return null;
  }

  return (
    <section className="flex flex-col gap-8">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div className="flex flex-col gap-2">
          <h2 className="text-[28px] font-semibold leading-9 text-black md:text-[32px] md:leading-10">
            {t("blogPage.relatedTitle")}
          </h2>
          <p className="text-xl font-normal leading-8 text-black/60 md:text-2xl">
            {t("blogPage.relatedSubtitle")}
          </p>
        </div>
        <Link
          href={blogHref(language, "/blog")}
          className="text-lg font-medium leading-7 text-black/60 underline underline-offset-4"
        >
          {t("blogPage.viewMore")}
        </Link>
      </div>

      {/* `auto-rows-fr` — see the note in blog-grid.tsx. */}
      <div className="grid auto-rows-fr grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3 xl:gap-10">
        {visible.map((post) => (
          <BlogCard key={post.id} post={post} variant="compact" />
        ))}
      </div>
    </section>
  );
}
